module.exports = __webpack_public_path__ + "images/emoji/flower_playing_cards.33843cb908c88e6a542e.png";